// Angular and Core
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// Shared
import { BlockableDivModule } from '../shared/components/blockable-div/blockable-div.module';
import { LanguageDialogModule } from '../shared/components/language/language.dialog.module';
import { SharedModule } from '../shared/shared.module';

// Primeng modules
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { KnobModule } from 'primeng/knob';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';
import { StepperModule } from 'primeng/stepper';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';


// Components
import { AcquireBoardUserDialogComponent } from './acquire-board-user-dialog/acquire-board-user.dialog.component';
import { BoardUserDialogComponent } from './board-user-dialog/board-user.dialog.component';
import { BoardUsersComponent } from './board-users/board-users.component';
import { BoardUsersExportListDialogComponent } from './board-users-export-list-dialog/board-users-export-list.dialog.component';
import { BoardUsersImportListDialogComponent } from './board-users-import-list-dialog/board-users-import-list.dialog.component';
import { BoardUsersListsComponent } from './board-users-lists/board-users-lists.component';
import { BoardUsersTableComponent } from './board-users-table/board-users-table.component';


@NgModule({
	declarations: [
		AcquireBoardUserDialogComponent,
		BoardUserDialogComponent,
		BoardUsersComponent,
		BoardUsersExportListDialogComponent,
		BoardUsersImportListDialogComponent,
		BoardUsersListsComponent,
		BoardUsersTableComponent,
	],
	imports: [
		AccordionModule,
		AutoCompleteModule,
		BadgeModule,
		BlockUIModule,
		BlockableDivModule,
		BreadcrumbModule,
		ButtonModule,
		CalendarModule,
		CardModule,
		CdkTreeModule,
		ChartModule,
		CheckboxModule,
		ChipModule,
		CommonModule,
		ConfirmDialogModule,
		DividerModule,
		DropdownModule,
		FileUploadModule,
		FormsModule,
		ImageModule,
		InputNumberModule,
		InputSwitchModule,
		InputTextareaModule,
		InputTextModule,
		KnobModule,
		LanguageDialogModule,
		ListboxModule,
		MenuModule,
		MultiSelectModule,
		PanelModule,
		ProgressBarModule,
		ProgressSpinnerModule,
		RadioButtonModule,
		ReactiveFormsModule,
		RippleModule,
		RouterModule,
		SelectButtonModule,
		SharedModule,
		SliderModule,
		StepperModule,
		TabViewModule,
		TableModule,
		TagModule,
		ToastModule,
		ToggleButtonModule,
		TooltipModule,
		TranslateModule,
		TreeModule,
		TreeTableModule
	],
	exports: [
		AcquireBoardUserDialogComponent,
		BoardUserDialogComponent,
		BoardUsersComponent,
		BoardUsersExportListDialogComponent,
		BoardUsersImportListDialogComponent,
		BoardUsersListsComponent,
		BoardUsersTableComponent,
	]
})
export class DevicesBoardUsersModule { }
